import React, { useState } from "react";
import { Autocomplete, Box, Grid, TextField, Typography } from "@mui/material";
import { truncateComment } from "utils/utils";
import Loader from "components/loader/Loader";
// import "../CommonMultiForm.scss";

const CommonGoogleAutoComplete = ({
  defaultValue,
  getOptionLabel,
  disabled,
  options,
  onHandleChange,
  onInputChange,
  ele,
  register,
  landmarkMandatory,
  fieldType,
  fieldLoader
}) => {
  const [searchInitiated, setSearchInitiated] = useState(false);

  const handleInputChange = (event, value) => {
    setSearchInitiated(!!value);
    onInputChange(event, value);
  };

  return (
    <Box className="customAutoComplete">
      <Autocomplete
        id="free-solo-demo"
        clearOnBlur={ele?.clearOnBlur}
        defaultValue={defaultValue}
        open={searchInitiated && options?.length}
        onClose={() => setSearchInitiated(false)}
        onBlur={() => setSearchInitiated(false)}
        popupIcon={null}
        getOptionLabel={getOptionLabel}
        disabled={disabled}
        options={options}
        onChange={onHandleChange}
        onInputChange={handleInputChange}
        renderOption={(props, option) => (
          <li {...props}>
            <Grid container>
              <Grid
                item
                justifyContent="start"
                className="marginLeft16 width375"
              >
                <Typography className="font14 fontNormal">
                  {truncateComment(
                    option?.name
                      ? option?.name
                      : option?.structured_formatting?.main_text,
                    50
                  )}
                </Typography>
                <Typography className="font12 colorGrey">
                  {truncateComment(
                    option?.vicinity
                      ? option?.name + "," + option?.vicinity
                      : option?.description,
                    50
                  )}
                </Typography>
              </Grid>
            </Grid>
          </li>
        )}
        renderInput={(params) => (
          <Box className="flex">
            {params.InputProps.startAdornment}
            <TextField
              {...params}
              margin="normal"
              className="inputStyle"
              placeholder={ele?.placeholder}
              InputProps={{
                ...params.InputProps,
              }}
              {...register(ele?.name, {
                required: ele?.name === "landMark" ? landmarkMandatory?.landMark : ele?.required || false,
              })}
            />
          </Box>
        )}
        noOptionsText={'No options'}
      />
      {fieldType === ele?.name && fieldLoader &&
      <Box className="autoCompleteLoader">
      <Loader height="66px" loaderSize={"small"} />
      </Box>
      }
    </Box>
  );
}

export default CommonGoogleAutoComplete;